import { useContext, useMemo } from "react";
import { PageStaticDataContext } from "../contexts/PageStaticDataContextProvider";
import { ProductContext } from "../contexts/ProductContextProvider";
import { BffDataContext } from "../contexts/BffDataContextProvider";
import { showTextBoxSelector } from "../utils/ProductBuilderHelper";

export function useRequiredTextboxFieldsWithError() {
  const {
    productBuilderOptions: { selections: productBuilderSelections },
  } = useContext(PageStaticDataContext);

  const { selections: userSelections = {}, clientSideStateInitialized } = useContext(
    ProductContext
  );
  const { compatibleRanges } = useContext(BffDataContext);

  const requiredFields: string[] = useMemo(() => {
    return productBuilderSelections
      .filter(unitSelection => unitSelection.selectionStyle === "Text box")
      .filter(unitSelection =>
        showTextBoxSelector(
          compatibleRanges[unitSelection.property.key],
          clientSideStateInitialized
        )
      )
      .map(unitSelection => unitSelection.property.key);
  }, [productBuilderSelections, compatibleRanges, clientSideStateInitialized]);

  const requiredFieldsWithError = requiredFields.filter(fieldName => !userSelections[fieldName]);

  return requiredFieldsWithError;
}
